import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "property-information" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = {
  key: 0,
  class: "options"
}
const _hoisted_4 = {
  key: 1,
  class: "no-options"
}
const _hoisted_5 = { class: "row q-mb-md" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_property_info_item = _resolveComponent("property-info-item")!
  const _component_add_icon = _resolveComponent("add-icon")!
  const _component_q_btn = _resolveComponent("q-btn")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[3] || (_cache[3] = _createElementVNode("div", { class: "divider properties" }, null, -1)),
    _cache[4] || (_cache[4] = _createElementVNode("div", { class: "row q-mb-sm" }, [
      _createElementVNode("h5", { class: "card-title" }, "Properties")
    ], -1)),
    _createElementVNode("div", _hoisted_2, [
      (Object.keys(_ctx.props ?? {}).length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.props, (propValue, propId) => {
              return (_openBlock(), _createBlock(_component_property_info_item, {
                editing: _ctx.editing,
                "prop-id": propId,
                "onUpdate:propId": ($event: any) => (_ctx.updatePropId(propId, $event)),
                "prop-value": propValue,
                "onUpdate:propValue": ($event: any) => (_ctx.updatePropValue(propId, $event)),
                "current-props": _ctx.props,
                "all-props": _ctx.allProps,
                "prop-values": _ctx.propValues[propId],
                ref_for: true,
                ref: (el) => el?.newPropMode ? _ctx.newNewProps[el.newProp.sys.id] = el.newProp : undefined,
                "onUpdate:newProp": _cache[0] || (_cache[0] = ($event: any) => (_ctx.newNewProps[$event.sys.id] = $event)),
                onRemove: _ctx.removeProp
              }, null, 8, ["editing", "prop-id", "onUpdate:propId", "prop-value", "onUpdate:propValue", "current-props", "all-props", "prop-values", "onRemove"]))
            }), 256))
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_4, _cache[1] || (_cache[1] = [
            _createElementVNode("h6", { class: "subtitle" }, "No properties found", -1)
          ])))
    ]),
    _createElementVNode("div", _hoisted_5, [
      (_ctx.editing)
        ? (_openBlock(), _createBlock(_component_q_btn, {
            key: 0,
            unelevated: "",
            rounded: "",
            onClick: _ctx.addProperty
          }, {
            default: _withCtx(() => [
              _createVNode(_component_add_icon, { left: "" }),
              _cache[2] || (_cache[2] = _createElementVNode("span", null, "Property", -1))
            ]),
            _: 1
          }, 8, ["onClick"]))
        : _createCommentVNode("", true)
    ])
  ]))
}